<script>
export default {
    name : "ProfileButton",
}
</script>
<script setup>
import { useMainStore } from '../stores/main';
import { storeToRefs }  from 'pinia';
import { computed }     from "vue";

let store = useMainStore();
const {
          lang,
          copydeck,
          creatingUser,
          profileModalMode,
          profileModalOpen,
          accounts,
          currentUserAccount,
      }   = storeToRefs( store );


function selectScreen ()
{
    profileModalMode.value = "select-account";

    const c = store.accounts;

    if ( accounts.value.length === 0 )
    {
        profileModalMode.value = "create-account";
    }

    profileModalOpen.value = true;
}
</script>

<template>
    <div class="header-profile-section">
        <button class="btn-primary btn-profile" @click=" selectScreen ">
            {{ copydeck?.profile?.btnProfile?.[ lang ] ?? '' }}
        </button>
        <div class="avatar-frame" v-if=" (currentUserAccount?.imageSquare ?? '') !== '' "><img :src=" '/images/accounts/' + currentUserAccount?.imageSquare ?? '' "></div>
    </div>
</template>
